<script lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import LandingLayout from './layouts/LandingLayout.vue';
import AuthenticatedLayout from './layouts/AuthenticatedLayout.vue';
import PublicDocumentLayout from './layouts/PublicDocument.vue';

export default {
  setup() {
    const route = useRoute();

    const layoutComponent = computed(() => {
      if (route.meta.layout === 'landing') {
        return LandingLayout;
      } else if (route.meta.layout === 'publicDocument') {
        return PublicDocumentLayout; // Use LandingLayout for public routes
      } else if (route.meta.layout === 'authenticated') {
        return AuthenticatedLayout;
      } else {
        return LandingLayout; // Fallback to AuthenticatedLayout for any other cases
      }
    });

    return {
      layoutComponent,
    };
  },
};
</script>

<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<style>
body::before {
  content: '';
  position: fixed;
  inset: 0; /* top:0; right:0; bottom:0; left:0 */
  z-index: -1; /* behind everything */
  background: linear-gradient(
      330deg,
      rgba(0, 76, 147, 0.5),
      rgba(163, 1, 95, 0.5)
    ),
    url('@/assets/images/background.webp');
  background-size: cover;
  background-position: right center;
  pointer-events: none; /* don’t block clicks */
}
#app {
  padding: 0;
  margin: 0;
}
/* Links */
a {
  cursor: pointer;
  color: #555;
  text-decoration: underline;
}
a:visited {
  color: #555;
  text-decoration: underline;
}
a:hover {
  color: #111;
}
/* Small buttons */
.btn-xs .btn {
  --bs-btn-font-size: 0.75rem;
  --bs-btn-padding-y: 0.125rem;
  --bs-btn-padding-x: 0.35rem;
  --bs-btn-border-radius: 0.2rem;
  --bs-btn-line-height: 1.5;
}
/* Google Materials Icon Pack */
.material-symbols-outlined,
.material-symbols-rounded,
.material-symbols-sharp {
  font-family: 'Material Symbols Outlined'; /* <- key line */
  font-weight: normal;
  font-style: normal;
  font-size: 1em; /* same size as surrounding text; use 24px if you prefer */
  font-feature-settings: 'liga';
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;

  /* variable font axes */
  font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}

/* Code Highlight Styles */
.code-highlight {
  font-size: 0.8em !important;
  max-width: 100%;
  /* Allow wrapping of long lines */
  white-space: pre-wrap;
  /* Break long words if needed */
  word-break: break-word;
  /* Enable horizontal scrolling if content exceeds container width */
  overflow-x: auto;
  padding: 10px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  box-sizing: border-box;
  text-align: left;
  color: darkslategray;
}

/* Browser table style */
.browser-table {
  font-size: 0.8rem;
  border-radius: 5px;
  overflow: visible !important;
}
.browser-table tbody tr:hover {
  cursor: pointer !important;
}

/* Transparent Table and Card Styles */
table.table tr.transparent-table th,
table.table tr.transparent-table td {
  background-color: transparent !important;
  border-bottom: 1px solid rgba(125, 126, 125, 0.1) !important;
}

.transparent-card,
.transparent-card > .card-body {
  background: none !important;
  padding: 0 !important;
  border: none !important;
}

/* large tooltips */
.large-tooltip .tooltip-inner {
  max-width: 500px !important;
}

.min-width {
  width: 1px !important;
  white-space: nowrap;
}
.accordion-title {
  background-color: #eee !important;
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E") !important;
}
.accordion-title:not(.collapsed) {
  color: #fff !important;
  background-color: #0c63e4 !important;
  --bs-accordion-btn-active-icon: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22%23fff%22 viewBox=%220 0 16 16%22%3E%3Cg transform=%22rotate(0,8,8)%22%3E%3Cpath fill-rule=%22evenodd%22 d=%22M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%22/%3E%3C/g%3E%3C/svg%3E') !important;
}
.expanded-group {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 1rem;
}
.collapsed-group {
  background: none;
  border-radius: 0.5rem;
  padding: 0;
}
</style>
